module.exports = __webpack_public_path__ + "static/img/24logo.f2ce563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/24logo.png
// module id = 74FA
// module chunks = 0